if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const variantInput = this.form.querySelector('[name="id"]');

        if (!variantInput) return;

        variantInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        if (!this.submitButton) return;

        /*
         * =========================================
         * iOS SAFARI TOUCH FIX
         * =========================================
         */

        const isIOS =
          /iPad|iPhone|iPod/.test(navigator.userAgent) ||
          (
            navigator.platform === 'MacIntel' &&
            navigator.maxTouchPoints > 1
          );

        if (isIOS) {
          let touchHandled = false;

          this.submitButton.addEventListener(
            'touchstart',
            () => {
              touchHandled = false;
            },
            {
              passive: true
            }
          );

          this.submitButton.addEventListener(
            'touchend',
            (event) => {
              if (touchHandled) return;

              touchHandled = true;

              event.preventDefault();

              setTimeout(() => {
                try {
                  if (this.form.requestSubmit) {
                    this.form.requestSubmit(
                      this.submitButton
                    );
                  } else {
                    this.form.dispatchEvent(
                      new Event('submit', {
                        bubbles: true,
                        cancelable: true
                      })
                    );
                  }
                } catch (e) {
                  console.error(
                    'iOS Add to Cart error:',
                    e
                  );
                }
              }, 10);

              setTimeout(() => {
                touchHandled = false;
              }, 1000);
            },
            {
              passive: false
            }
          );
        }

        /*
         * =========================================
         * CART DRAWER
         * =========================================
         */

        if (
          document.querySelector('cart-drawer')
        ) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';

        /*
         * =========================================
         * VARIANT LIST
         * =========================================
         */

        const selectElement =
          this.form.querySelector('[name="id"]');

        const listItems =
          this.form.querySelectorAll(
            '#variantList li'
          );

        if (
          listItems &&
          listItems.length > 0
        ) {
          listItems.forEach((item) => {
            item.addEventListener(
              'click',
              function (event) {
                const value =
                  this.getAttribute('data-value');

                const variantPrice =
                  this.getAttribute('data-price');

                const variantQTY =
                  this.getAttribute('data-inventory');

                selectElement.value = value;

                const closestList =
                  event.target.parentElement.closest(
                    '.variantPick'
                  );

                if (closestList) {
                  const priceContainer =
                    closestList.querySelector(
                      '.price-item--sale'
                    );

                  if (priceContainer) {
                    priceContainer.innerHTML =
                      variantPrice;
                  }
                }

                const variantMedia =
                  this.getAttribute(
                    'data-variant-media'
                  );

                const cardWrapper =
                  this.closest('.card-wrapper');

                if (
                  cardWrapper &&
                  variantMedia
                ) {
                  const featuredMedia =
                    cardWrapper.querySelector(
                      '.card__inner .featured-media'
                    );

                  if (featuredMedia) {
                    featuredMedia.setAttribute(
                      'srcset',
                      variantMedia
                    );
                  }
                }
              }
            );
          });
        }
      }

      /*
       * =========================================
       * ADD TO CART
       * =========================================
       */

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        const spinner =
          this.querySelector(
            '.loading-overlay__spinner'
          );

        if (spinner) {
          spinner.classList.remove(
            'hidden'
          );
        }

        const config =
          fetchConfig('javascript');

        config.headers =
          config.headers || {};

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        delete config.headers[
          'Content-Type'
        ];

        const formData =
          new FormData(this.form);

        if (this.cart) {
          try {
            formData.append(
              'sections',
              this.cart
                .getSectionsToRender()
                .map(
                  (section) => section.id
                )
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );

            this.cart.setActiveElement(
              document.activeElement
            );
          } catch (e) {
            console.error(
              'Cart preparation error:',
              e
            );
          }
        }

        config.body = formData;

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) =>
            response.json()
          )

          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              const buttonText =
                this.submitButton.querySelector(
                  'span'
                );

              if (buttonText) {
                buttonText.classList.add(
                  'hidden'
                );
              }

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }

            if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            this.error = false;

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(
                      response
                    );
                  });
                },
                {
                  once: true
                }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(
                response
              );
            }
          })

          .catch((e) => {
            console.error(
              'Add to Cart error:',
              e
            );
          })

          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }

            setTimeout(() => {
              giftCart();
            }, 1000);
          });
      }

      /*
       * =========================================
       * ERROR MESSAGE
       * =========================================
       */

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}


/*
 * =============================================
 * AJAX COMPLETE
 * =============================================
 */

$(document).ajaxComplete(function () {
  // CartJS.updateCart();
});


/*
 * =============================================
 * GIFT CART
 * =============================================
 */

function giftCart() {
  const cartItems =
    document.querySelectorAll(
      'tr.cart-item'
    );

  cartItems.forEach((cartItem) => {
    const dataId =
      cartItem.getAttribute('data-id');

    const drawerFooter =
      document.querySelector(
        `#Gift-Wrapper[data-id="${dataId}"]`
      );

    if (!drawerFooter) return;

    const drawerFooterID =
      drawerFooter.getAttribute(
        'data-id'
      );

    if (drawerFooterID == dataId) {
      drawerFooter.classList.add(
        'Gift-Wrapper__hide'
      );
    }
  });
}